let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1n8w9")).then(() => parcelRequire('8mq9f'));